import * as React from 'react';

import pngBackgroundBase64 from '../assets/png-background.png';
import slotPlaceholderBase64 from '../assets/slot-placeholder.png';

type Props = {
  path: string | null;
  templateSize: { width: number; height: number };
  size: { width: number; height: number };
  scale: { width: number; height: number };
  rotation: number;
  position: { x: number; y: number };
};

export function SlotPathCard({ path, templateSize, size, scale, rotation, position }: Props) {
  const imageId = React.useMemo(() => Math.random().toString(36).substring(2, 15), []);

  const scaledWidth = size.width * scale.width;
  const scaledHeight = size.height * scale.height;

  return (
    <div
      style={{
        background: `url("${pngBackgroundBase64}")`,
        backgroundSize: '100% 100%',
        width: '100%',
        aspectRatio: `${templateSize.width}/${templateSize.height}`,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        baseProfile="full"
        viewBox={`0 0 ${templateSize.width} ${templateSize.height}`}
        width="100%"
        height="100%"
      >
        <defs>
          <pattern id={imageId} patternUnits="userSpaceOnUse" width={171} height={234}>
            <image href={slotPlaceholderBase64} x={0} y={0} width={171} height={234} />
          </pattern>
        </defs>
        <path
          d={path ?? `M 0 0 L ${size.width} 0 L ${size.width} ${size.height} L 0 ${size.height} Z`}
          fill={`url(#${imageId})`}
          transform={`translate(${position.x - scaledWidth / 2}, ${position.y - scaledHeight / 2}) scale(${scale.width}, ${scale.height}) rotate(${rotation * (180 / Math.PI)}, ${scaledWidth / 2}, ${scaledHeight / 2})`}
        />
      </svg>
    </div>
  );
}
